export const NAME = 'featureFlag' as const
